module.exports = __webpack_public_path__ + "img/page17.43ec4f42.jpg";